// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__Gp0e0","text":"footer_text__2kNsF","footer__icon":"footer_footer__icon__mcdu4","footer__icon__wrapper":"footer_footer__icon__wrapper__30Lap"};